var map = {
	"./Apple2.png": 94985,
	"./Ball2.png": 612,
	"./Banana2.png": 77176,
	"./Bird.png": 93506,
	"./Books.png": 61533,
	"./Bus.png": 44577,
	"./Cars.png": 20406,
	"./CarsAndBicycle.png": 43984,
	"./Cat2.png": 75261,
	"./Circle.png": 17247,
	"./Dog.png": 85053,
	"./Flower2.png": 99734,
	"./Grapes.png": 89755,
	"./Orange.png": 56397,
	"./Pear.png": 93067,
	"./Pineapple.png": 83221,
	"./Square.png": 54430,
	"./Triangle.png": 83143,
	"./apple.png": 45235,
	"./baby.png": 49295,
	"./bag.png": 68985,
	"./ball.png": 79020,
	"./banana.png": 23448,
	"./bed.png": 4558,
	"./bicycle.png": 34312,
	"./boat.png": 24561,
	"./book.png": 10556,
	"./boot.png": 90523,
	"./cat.png": 35551,
	"./chair.png": 67084,
	"./check.png": 52323,
	"./cow.png": 2358,
	"./crocodile.png": 74723,
	"./cross.png": 33443,
	"./cup.png": 8103,
	"./doll.png": 84464,
	"./dysmate-logo-hvit-small.png": 27302,
	"./ear.png": 58691,
	"./elephant.png": 25964,
	"./eye.png": 79988,
	"./finger.png": 14144,
	"./fireengine.png": 70121,
	"./fish.png": 83909,
	"./flower.png": 92790,
	"./flowers.png": 63487,
	"./foot.png": 23823,
	"./giraffe.png": 43391,
	"./gloves.png": 88369,
	"./horse.png": 99844,
	"./house.png": 84527,
	"./house2.png": 41677,
	"./icecream.png": 15842,
	"./jeans.png": 52946,
	"./key.png": 58062,
	"./laptop-icon.png": 57637,
	"./lion.png": 36013,
	"./literate-regular-light.png": 79033,
	"./logo-white-2.png": 57331,
	"./motorcycle.png": 38020,
	"./nose.png": 93498,
	"./package.png": 56451,
	"./pc-icon.png": 12932,
	"./plane.png": 27845,
	"./plowtruck.png": 84532,
	"./porrige.png": 65127,
	"./purse.png": 56146,
	"./rabbit.png": 37347,
	"./rapidNaming/bamse.png": 10924,
	"./rapidNaming/blabamse.png": 46783,
	"./rapidNaming/blaeple.png": 54493,
	"./rapidNaming/blagenser.png": 5331,
	"./rapidNaming/blasykkel.png": 43062,
	"./rapidNaming/blatommel.png": 34877,
	"./rapidNaming/de/dog-blue.png": 22591,
	"./rapidNaming/de/dog-brown.png": 53591,
	"./rapidNaming/de/dog-green.png": 96986,
	"./rapidNaming/de/dog-grey.png": 66490,
	"./rapidNaming/de/dog-red.png": 87198,
	"./rapidNaming/de/dog-yellow.png": 45691,
	"./rapidNaming/de/door-blue.png": 34143,
	"./rapidNaming/de/door-brown.png": 56439,
	"./rapidNaming/de/door-green.png": 63546,
	"./rapidNaming/de/door-grey.png": 55930,
	"./rapidNaming/de/door-red.png": 85918,
	"./rapidNaming/de/door-yellow.png": 47675,
	"./rapidNaming/de/moon-blue.png": 22422,
	"./rapidNaming/de/moon-brown.png": 34388,
	"./rapidNaming/de/moon-green.png": 56165,
	"./rapidNaming/de/moon-grey.png": 20063,
	"./rapidNaming/de/moon-red.png": 69621,
	"./rapidNaming/de/moon-yellow.png": 16246,
	"./rapidNaming/de/shoe-blue.png": 69344,
	"./rapidNaming/de/shoe-brown.png": 14570,
	"./rapidNaming/de/shoe-green.png": 59715,
	"./rapidNaming/de/shoe-grey.png": 83573,
	"./rapidNaming/de/shoe-red.png": 53587,
	"./rapidNaming/de/shoe-yellow.png": 55564,
	"./rapidNaming/de/tree-blue.png": 78419,
	"./rapidNaming/de/tree-brown.png": 77683,
	"./rapidNaming/de/tree-green.png": 8430,
	"./rapidNaming/de/tree-grey.png": 11622,
	"./rapidNaming/de/tree-red.png": 3106,
	"./rapidNaming/de/tree-yellow.png": 88063,
	"./rapidNaming/elefant.png": 59641,
	"./rapidNaming/eple.png": 5444,
	"./rapidNaming/genser.png": 62782,
	"./rapidNaming/grabamse.png": 87966,
	"./rapidNaming/graeple.png": 12850,
	"./rapidNaming/gragenser.png": 10708,
	"./rapidNaming/grasykkel.png": 2513,
	"./rapidNaming/gratommel.png": 46386,
	"./rapidNaming/gronnbamse.png": 9736,
	"./rapidNaming/gronneple.png": 92848,
	"./rapidNaming/gronngenser.png": 65362,
	"./rapidNaming/gronnsykkel.png": 44523,
	"./rapidNaming/gronntommel.png": 6668,
	"./rapidNaming/oransjebamse.png": 31352,
	"./rapidNaming/oransjeeple.png": 68320,
	"./rapidNaming/oransjegenser.png": 46498,
	"./rapidNaming/oransjesykkel.png": 91323,
	"./rapidNaming/oransjetommel.png": 36220,
	"./rapidNaming/paraply.png": 39599,
	"./rapidNaming/prinsesse.png": 31802,
	"./rapidNaming/rodbamse.png": 80835,
	"./rapidNaming/rodeple.png": 82577,
	"./rapidNaming/rodgenser.png": 68815,
	"./rapidNaming/rodsykkel.png": 84754,
	"./rapidNaming/rodtommel.png": 70985,
	"./rapidNaming/se/apple-blue.png": 87230,
	"./rapidNaming/se/apple-green.png": 28573,
	"./rapidNaming/se/apple-grey.png": 82951,
	"./rapidNaming/se/apple-orange.png": 72608,
	"./rapidNaming/se/apple-red.png": 22621,
	"./rapidNaming/se/bike-blue.png": 84747,
	"./rapidNaming/se/bike-green.png": 22550,
	"./rapidNaming/se/bike-grey.png": 81822,
	"./rapidNaming/se/bike-orange.png": 1457,
	"./rapidNaming/se/bike-red.png": 20154,
	"./rapidNaming/se/flower-blue.png": 91821,
	"./rapidNaming/se/flower-green.png": 9172,
	"./rapidNaming/se/flower-grey.png": 53748,
	"./rapidNaming/se/flower-orange.png": 61927,
	"./rapidNaming/se/flower-red.png": 15280,
	"./rapidNaming/se/woman-blue.png": 80648,
	"./rapidNaming/se/woman-green.png": 35611,
	"./rapidNaming/se/woman-grey.png": 87549,
	"./rapidNaming/se/woman-orange.png": 76174,
	"./rapidNaming/se/woman-red.png": 11195,
	"./rapidNaming/se/zebra-blue.png": 3134,
	"./rapidNaming/se/zebra-green.png": 69373,
	"./rapidNaming/se/zebra-grey.png": 25639,
	"./rapidNaming/se/zebra-orange.png": 14176,
	"./rapidNaming/se/zebra-red.png": 8989,
	"./rapidNaming/stoevsuger.png": 25983,
	"./rapidNaming/sykkel.png": 8935,
	"./rapidNaming/tannboerste.png": 33861,
	"./rapidNaming/tommel.png": 16936,
	"./reflex.png": 46657,
	"./saft.png": 11101,
	"./server-icon.png": 28470,
	"./sheep.png": 70102,
	"./shoe.png": 5186,
	"./ski.png": 10204,
	"./spoon.png": 23612,
	"./sun.png": 12873,
	"./sweater.png": 42414,
	"./teddy.png": 55793,
	"./telephone.png": 86199,
	"./tractor.png": 75130,
	"./whale.png": 9940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;